


































import { Ref, Prop, Vue, Component } from "vue-property-decorator";
import { UIModel } from "./UIModel";

// Imports Components
import CPSHeader from "./components/layout/header.vue";
import CPSToolbar from "./components/layout/toolbar.vue";
import CPSMenu from "./components/layout/menu.vue";
import CPSFooter from "./components/layout/footer.vue";
import cookie from "js-cookie";

@Component({
    components: {
        CPSHeader,
        CPSToolbar,
        CPSMenu,
        CPSFooter
    },
})
export default class App extends Vue {
  public model = new UIModel();
  public isModelInitLoaded = false;
  public fullPath;

  get isConectio() {
      return window.location.hostname.toLowerCase().includes("conectio");
  }

  public async created() {
      try {
          //await only one request for refreshing the token 
          this.fullPath = this.$route.fullPath;
          this.redirectTo();
          await this.model.getHubs();
          await this.model.init();
          this.isModelInitLoaded = true;
          if (this.model.settings.action_required) {
              this.$router.push('/settings').catch(()=>{});
          } else {
              //this.$router.push('/').catch(()=>{});
          }
      } catch(error) {
          if(this.fullPath.includes("/project-access-approval")) {
              this.saveRedirectToCookies();
          }
      }
  }

  private redirectTo() {
      const url = cookie.get('redirect_to');
      if(url) {
          cookie.remove('redirect_to');
          this.$router.push(url);
      }
  }

  private saveRedirectToCookies() {
      let exp = new Date();
      exp.setSeconds(exp.getSeconds() + 1209600); // 14 days
      cookie.set('redirect_to', this.fullPath, { expires: exp });
  }
}
